module.exports = __webpack_public_path__ + "static/media/baseMeme2.9db97415.jpg";